import React from 'react';
import { Heading, SectionLabel } from '../components/ui-bits';
import CTABanner from '../components/CTABanner';
import { LogoMark } from '../components/Logo';
import { CERTIFIED_LEVELS, CERTIFIED_STANDARDS, TEAM } from '../data/mock';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export default function Certified() {
  return (
    <main className="pt-32">
      <section className="max-w-[1240px] mx-auto px-6 md:px-10 py-16">
        <SectionLabel>Sunday Mirror Certified</SectionLabel>
        <Heading className="mt-5 font-serif max-w-4xl">Trust, <span className="italic">verified before the wedding.</span></Heading>
        <p className="mt-6 max-w-2xl text-[#4a5c60] text-lg leading-relaxed">A beautiful portfolio is not enough. Every professional carrying the Sunday Mirror Certified mark passes a structured review designed for destination-wedding delivery.</p>
      </section>

      <section className="bg-[#053e49] text-[#faf4ea] py-24 relative overflow-hidden">
        <div className="absolute -top-10 -right-20 opacity-[0.06]"><LogoMark size={520} /></div>
        <div className="relative max-w-[1240px] mx-auto px-6 md:px-10 grid lg:grid-cols-2 gap-16">
          <div>
            <SectionLabel dark>The Standard</SectionLabel>
            <ul className="mt-8 space-y-4">
              {CERTIFIED_STANDARDS.map((s, i) => (
                <li key={s} className="flex gap-4"><span className="font-serif text-[#c3a66d] text-sm pt-1">{String(i+1).padStart(2,'0')}</span><span className="text-[#e4ddc8]">{s}</span></li>
              ))}
            </ul>
          </div>
          <div>
            <SectionLabel dark>Quality that earns its level</SectionLabel>
            <div className="mt-8 space-y-8">
              {CERTIFIED_LEVELS.map((l, i) => (
                <div key={l.level} className="border border-[#0b5260] p-6 hover:border-[#c3a66d] transition-colors">
                  <div className="flex items-center gap-3"><div className="w-10 h-10 border border-[#c3a66d] flex items-center justify-center text-[#c3a66d] font-serif">{i+1}</div><h3 className="font-serif text-2xl text-[#ffeabf]">{l.level}</h3></div>
                  <p className="mt-4 text-[#a8b7bb]">{l.body}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="relative max-w-[900px] mx-auto px-6 md:px-10 mt-16 text-center">
          <p className="font-serif italic text-xl text-[#ffeabf]">This is not a popularity badge. It is Sunday Mirror’s system for building more predictable service quality—wherever the wedding takes place.</p>
        </div>
      </section>

      <section className="bg-[#fbf8f2] py-24">
        <div className="max-w-[1240px] mx-auto px-6 md:px-10">
          <SectionLabel>Meet certified professionals</SectionLabel>
          <Heading className="mt-5 font-serif">Great weddings are built by <span className="italic">great people.</span></Heading>
          <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {TEAM.map((t) => (
              <div key={t.name} className="group bg-white border border-[#e8e0d2]">
                <div className="aspect-[4/5] overflow-hidden"><img src={t.photo} alt={t.name} className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700" /></div>
                <div className="p-5">
                  <div className="eyebrow text-[#a6894f]">{t.role}</div>
                  <h3 className="font-serif text-xl text-[#053e49] mt-1">{t.name}</h3>
                  <div className="text-xs text-[#6b7c80] mt-3">{t.destinations}</div>
                  <div className="text-xs text-[#6b7c80]">{t.languages}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-10 text-center"><Link to="/team" className="btn-outline-dark">Browse Full Directory <ArrowRight size={16} /></Link></div>
        </div>
      </section>

      <CTABanner />
    </main>
  );
}
